import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import CityPage from './pages/CityPage';
import AuditPage from './pages/AuditPage';
import PricingPage from './pages/PricingPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import CaseStudyDetailPage from './pages/CaseStudyDetailPage';

// Service Pages
import LocalSEO from './pages/services/LocalSEO';
import AEOPage from './pages/services/AEOPage';
import ContentMarketing from './pages/services/ContentMarketing';
import WebDesign from './pages/services/WebDesign';
import VoiceAutomation from './pages/services/VoiceAutomation';
import CRMService from './pages/services/CRMService';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen font-sans text-slate-900 bg-white">
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/city/:citySlug" element={<CityPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<AuditPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/case-studies/:studyId" element={<CaseStudyDetailPage />} />
            
            {/* Service Routes */}
            <Route path="/services/local-seo" element={<LocalSEO />} />
            <Route path="/services/aeo" element={<AEOPage />} />
            <Route path="/services/voice-automation" element={<VoiceAutomation />} />
            <Route path="/services/crm-system" element={<CRMService />} />
            <Route path="/services/content-marketing" element={<ContentMarketing />} />
            <Route path="/services/web-design" element={<WebDesign />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;